import { render, staticRenderFns } from "./admin_list.vue?vue&type=template&id=6da81ee5&scoped=true"
import script from "./admin_list.vue?vue&type=script&lang=js"
export * from "./admin_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da81ee5",
  null
  
)

export default component.exports